let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dvtK8")).then(() => parcelRequire('8rjeX'));